import { render } from "./appheader.vue?vue&type=template&id=784964de&scoped=true"
import script from "./appheader.vue?vue&type=script&lang=js"
export * from "./appheader.vue?vue&type=script&lang=js"

import "./appheader.vue?vue&type=style&index=0&id=784964de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784964de"]])

export default __exports__